import { BarleyIcon } from './BarleyIcon';

/**
 * author: Austin Andrews
 * id 5126A5A7-ECBC-49FC-BBC6-1703DCACF5E4
 * name barley
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barley.svg
 * tags
 * - Agriculture 
 * - Food / Drink 
 */
export const GlutenIcon = BarleyIcon;
export default GlutenIcon